import { render, staticRenderFns } from "./Users.vue?vue&type=template&id=4515db5a&scoped=true"
import script from "./Users.vue?vue&type=script&lang=ts"
export * from "./Users.vue?vue&type=script&lang=ts"
import style0 from "./Users.vue?vue&type=style&index=0&id=4515db5a&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4515db5a",
  null
  
)

export default component.exports